import { render, staticRenderFns } from "./MinusPlus.vue?vue&type=template&id=171a74ae"
import script from "./MinusPlus.vue?vue&type=script&lang=js"
export * from "./MinusPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports